import { makeStyles } from '@material-ui/core/styles';
import { Handle, Position } from '@xyflow/react';
import { useTranslation } from 'react-i18next';
import { color } from '../../app/theme';

const useStyles = makeStyles(
  {
    root: {
      fontSize: '15px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$7,
      background: color.$3,
      padding: '8px 12px',
      borderRadius: '16px',
    },
    handle: {
      border: '0 !important',
      borderRadius: '0 !important',
      background: `${color.$3} !important`,
      width: '1px !important',
      height: '1px !important',
      minWidth: '1px !important',
      minHeight: '1px !important',
    },
  },
  {
    name: 'Start',
  },
);

const StartComponent = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div>
      <Handle
        className={classes.handle}
        type="target"
        position={Position.Top}
        style={{ top: 0 }}
      />
      <div className={classes.root}>{t('start-node')}</div>
      <Handle
        className={classes.handle}
        type="source"
        position={Position.Bottom}
        style={{ bottom: 0 }}
      />
    </div>
  );
};

export default StartComponent;
